export default "__VITE_ASSET__BYjytkZC__"